import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=92d7bca0&scoped=true"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"
import style0 from "./VersionList.vue?vue&type=style&index=0&id=92d7bca0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d7bca0",
  null
  
)

export default component.exports